import {FC} from 'react'
import {Button, Col, Container, Image, Row} from 'react-bootstrap'
import {useNavigate} from 'react-router-dom'
import Error404Image from '../../../../assets/img/404.png'

const Error404: FC = () => {
  const navigate = useNavigate()
  return (
    <Container
      fluid
      className='d-flex flex-column justify-content-center align-items-center text-center min-vh-100'
      style={{padding: '2rem', backgroundColor: '#FFF'}}
    >
      <Row className='justify-content-center'>
        <Col md={24} lg={24}>
          {/* Gambar ilustrasi */}
          <Image
            src={Error404Image}
            alt='404 Not Found'
            style={{
              width: '70%',
              height: 'auto',
            }}
            className='mb-4'
          />

          {/* Judul */}
          <h2 className='mb-3 my-4' style={{textTransform: 'none', color: '#1C3177'}}>
            Uops, Halaman Tidak ditemukan
          </h2>

          {/* Deskripsi */}
          <p className='my-4'>
            Halaman yang Anda cari tidak ditemukan. Kami sarankan Anda kembali ke beranda.
          </p>

          {/* Tombol kembali */}
          <Button
            className='btn btn-primary btn-sm mt-3 px-4'
            style={{
              background: 'var(--Primary-L-500, #F95E2F)',
              borderRadius: '50px', // ini yang bikin pill
              border: 'none',
            }}
            onClick={() => navigate(-1)}
          >
            Kembali ke halaman sebelumnya
          </Button>
        </Col>
      </Row>
    </Container>
  )
}

export {Error404}
